/**
 * Created by Alex Aguilar on 8/2/2016.
 */
(function(){
    'use strict';

    var inlineValidateRadio = {
        template: '<span class="inline-validate"></span>',
        controller: inlineValidateRadioController,
        controllerAs: 'vm'
    };

    angular
        .module('completeAir')
        .component('inlineValidateRadio', inlineValidateRadio);

    inlineValidateRadio.$inject = ['$element']

    function inlineValidateRadioController($element){
        var vm = this;
        vm.$postLink = function() {
            $element.parent().addClass('inline-validate-required');
        }
    }

})();


